import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

/**
 * Formats a value in minutes-from-midnight to 12h AM/PM string.
 * e.g., 0 → "12:00 AM", 60 → "1:00 AM", 720 → "12:00 PM", 1439 → "11:59 PM"
 */
const formatMinutesToTime = (val) => {
  const todayMidnight = new Date().setHours(0, 0, 0, 0);
  return dayjs(todayMidnight)
    .add(dayjs.duration(val, 'minutes'))
    .format('h:mm A');
};

export default formatMinutesToTime;
